/**
 * A text box or select on the shared tokens (packages/ui theme README:
 * inputs sit on `bgSubtle` with a `border`): `body` text in `text.primary`,
 * 40px tall, rounded. Spread it and override the width or flex where it sits.
 * The Customers screens' `input` is this same style.
 */
import type React from 'react';
import { tokenVars } from '@turn-connect/ui';

export const fieldStyle: React.CSSProperties = {
  width: '100%',
  minHeight: 40,
  padding: '8px 12px',
  borderRadius: 8,
  border: `1px solid ${tokenVars.border}`,
  background: tokenVars.bgSubtle,
  color: tokenVars.text.primary,
  fontSize: 13,
  boxSizing: 'border-box',
};
